import { initSidebar } from './sidebar';

$(function() {
    "use strict";

    if (typeof clock === "function") {
        clock();
    }

    datepicker();

    initSidebar();
});
